export const cognitoConfig = {
  userPoolId: 'eu-west-1_VNWMDZU3t',
  clientId: '62rc9245u9lnh5l1e9jg86rm8d',
  region: 'eu-west-1',
}
